// **************************************************
//              GP Price Slider
// **************************************************

(function($) {
  'use strict';


var red_line = $('.gp-price-slider').find('.red-line');
var input_field_min = $('.gp-price-slider').find('input.input-min');
var input_field_max = $('.gp-price-slider').find('input.input-max');
var price_values = $('.gp-price-slider').find('.price-values');
var number_of_values = price_values.find('.value').length;

var set_min_val = price_values.find('.input-min').attr('data-index');
var set_max_val = price_values.find('.input-max').attr('data-index');

setMinValue(set_min_val);
setMaxValue(set_max_val);



// console.log(number_of_values);

// moves price slider position, sets input value, and data-attributes
function setMinValue(value_index){

    // min value can't be higher than max value
    if (value_index >= input_field_max.attr('data-index')){
        return;
    }

    // set value index between 1 and max value
    if (value_index > number_of_values){
        value_index = number_of_values;
    } else if (value_index < 1){
        value_index = 1;
    }

    // change css for red_line, set data-index values and data-price values
    red_line.css({ 'left' : 100 * (value_index - 1) / (number_of_values - 1) + '%' });
    red_line.attr('index-min', value_index);
    var this_index = price_values.find('.value-' + value_index);
    input_field_min.val(this_index.attr('data-price'));
    input_field_min.attr('data-index', this_index.attr('data-index'));
    input_field_min.attr('data-price', this_index.attr('data-price'));
}

// moves price slider position, sets input value, and data-attributes
function setMaxValue(value_index){

    // max value can't be less than min value
    if (value_index <= input_field_min.attr('data-index')){
        return;
    }

    // set value index between 1 and max value
    if (value_index > number_of_values){
        value_index = number_of_values;
    } else if (value_index < 1){
        value_index = 1;
    }

    // change css for red_line, set data-index values and data-price values
    red_line.css({ 'right' : 100 - (100 * (value_index - 1) / (number_of_values - 1)) + '%' });
    red_line.attr('index-max', value_index);
    var this_index = price_values.find('.value-' + value_index);
    input_field_max.val(this_index.attr('data-price'));
    input_field_max.attr('data-index', this_index.attr('data-index'));
    input_field_max.attr('data-price', this_index.attr('data-price'));
}

// clicking and dragging the gp-price-slider
var slider_clicked = false;
$('#gp-price-slider-wrapper').on("mousedown", function(e) {

    slider_clicked = true;
    e.preventDefault();

    // current_min = $('input.input-min').val();

    var left_offset = $('.grey-line').offset().left;
    var line_width = $('.grey-line').width();
    var mouse_relative = e.pageX - left_offset;

    // get mouse distance from current min and max values
    var red_line_min_offset_left = red_line.offset().left;
    var red_line_max_offset_left = red_line_min_offset_left + red_line.width();
    var mouse_distance_max = Math.abs(red_line_max_offset_left - e.pageX);
    var mouse_distance_min = Math.abs(e.pageX - red_line_min_offset_left);

    // change either the min OR the max value
    changing_min = false;
    changing_max = false;

    if (mouse_distance_max <= mouse_distance_min){
        var changing_max = true;
    } else {
        var changing_min = true;
    }
    // get pixel position of each price from left of the slider
    var breakpoints = [];
    for (let i = 1; i <= number_of_values; i++) {
        breakpoints.push( (i - 1) * line_width / (number_of_values - 1) );
    }

    // find breakpoint that is closest to mouse_relative
    var something = 99999;
    for (let i = 1; i <= number_of_values; i++) {
        var proposed_value = Math.abs(mouse_relative - breakpoints[i - 1]);

        if (proposed_value <= something){
            something = proposed_value;
            var closest_index = i;
        }
    }

    if (changing_min) {
        setMinValue(closest_index);
    }
    else if (changing_max){
        setMaxValue(closest_index);
    }

    // if mouse is held down, repeat the same code
    $(document).on('mousemove',function(e){
        // console.log('mouse-move');
        left_offset = $('.grey-line').offset().left;
        line_width = $('.grey-line').width();
        mouse_relative = e.pageX - left_offset;

        // get pixel position of each price from left of the slider
        var breakpoints = [];
        for (let i = 1; i <= number_of_values; i++) {
            breakpoints.push( (i - 1) * line_width / (number_of_values - 1) );
        }

         // find breakpoint that is closest to mouse position
        var something = 99999;
        for (let i = 1; i <= number_of_values; i++) {
            proposed_value = Math.abs(mouse_relative - breakpoints[i - 1]);

            if (proposed_value <= something){
                something = proposed_value;
                var closest_index = i;
            }
        }

        // change an endpoint
        if (changing_min) {
            setMinValue(closest_index);
        }
        else if (changing_max){
            setMaxValue(closest_index);
        }

    });
});

// unbind the mousemove
$(document).on('mouseup', function(e){
    if (slider_clicked){
        $(document).off('mousemove');
        slider_clicked = false;
    }
});

}(jQuery));
